export default __webpack_public_path__ + "static/media/4.a34b3a18.jpg";